var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrapper"},[_c('el-pagination',{attrs:{"current-page":_vm.paginationCurrentPage,"layout":_vm.total > 0 ? 'total, prev, pager, next' : 'prev, pager, next',"total":_vm.total,"prev-text":"上一页","next-text":"下一页"},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }